import React from "react";

import { Drawer } from "@components";
import Orders from "../Orders/Orders";
import { ShutdownDrawer } from "pages/Catalog/ShutdownDrawer";
import ResetPassword from "./Drawers/ResetPassword";
import ConfirmLoginDrawer from "./Drawers/ConfirmLoginDrawer";
import ManualConfirmLoginDrawer from "./Drawers/ManualConfirmLoginDrawer";
import BenefitManager from "../BenefitManager";
import BlockedCustomers from "./Drawers/BlockedCustomers";

export const DrawerTypes = {
  ORDERS: "ORDERS",
  SHUTDOWN_CATALOG: "SHUTDOWN_CATALOG",
  CONFIRM_LOGIN: "CONFIRM_LOGIN",
  RESET_PASSWORD: "RESET_PASSWORD",
  BENEFIT_MANAGER: "BENEFIT_MANAGER",
  BLOCKED_CUSTOMERS: "BLOCKED_CUSTOMERS",
  BLOCK_BENEFITS: "BLOCK_BENEFITS",
};

export class StartMobileDrawer extends React.Component {
  state = {
    data: null,
  };

  onClose() {
    const { onClose } = this.props;
    this.setState({ data: null }, onClose);
  }

  render() {
    const { visible, setting, onClose } = this.props;

    switch (setting) {
      case DrawerTypes.ORDERS:
        return (
          <Drawer
            visible={visible}
            onClose={onClose}
            showCloseButton={false}
            withoutPadding
          >
            <Orders />
          </Drawer>
        );
      case DrawerTypes.SHUTDOWN_CATALOG:
        return (
          <ShutdownDrawer
            visible={visible}
            onClose={onClose}
            showCloseButton={false}
            withoutPadding
          />
        );
      case DrawerTypes.CONFIRM_LOGIN:
        return (
          <ManualConfirmLoginDrawer
            visible={visible}
            onSave={onClose}
            onClose={onClose}
          />
        );
      case DrawerTypes.RESET_PASSWORD:
        return (
          <ResetPassword visible={visible} onSave={onClose} onClose={onClose} />
        );
      case DrawerTypes.BENEFIT_MANAGER:
        return (
          <BenefitManager
            visible={visible}
            onSave={onClose}
            onClose={onClose}
          />
        );
      case DrawerTypes.BLOCKED_CUSTOMERS:
        return (
          <BlockedCustomers
            visible={visible}
            onSave={onClose}
            onClose={onClose}
          />
        );
      default:
        return null;
    }
  }
}
